export const addZeroBeforeTimeUnit = (unit: number) => {
  if (unit < 10) {
    return `0${unit}`.slice(-2)
  }
  return `${unit}`
}
